import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const TeacherDashboard = () => {
  const [stats, setStats] = useState({
    totalSessions: 0,
    lastSessionDate: '-',
    totalSubjects: 0,
  });
  const [recentSessions, setRecentSessions] = useState([]);
  const teacherId = localStorage.getItem("userId");
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`http://localhost:8081/api/teacher/dashboard-stats/${teacherId}`)
      .then(res => setStats(res.data))
      .catch(err => console.error(err));

    axios.post('http://localhost:8081/api/teacher/recent-sessions', { teacher_id: teacherId })
      .then(res => setRecentSessions(res.data.sessions))
      .catch(err => console.error(err));
  }, [teacherId]);

  function formatToDayMonth(dateString) {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
    return `${day} ${month}`;
  }

  return (
    <div className="teacher-dashboard-container">
      <h1 className="dashboard-header">Teacher Dashboard</h1>

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total Sessions</h3>
          <p>{stats.totalSessions}</p>
        </div>
        <div className="stat-card">
          <h3>Total Subjects</h3>
          <p>{stats.totalSubjects}</p>
        </div>
        <div className="stat-card">
          <h3>Last Session</h3>
          <p>{stats.lastSessionDate}</p>
        </div>
      </div>

      <div className="recent-sessions">
        <h2>Recent Sessions</h2>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Subject</th>
              <th>Program</th>
              <th>Students Present</th>
            </tr>
          </thead>
          <tbody>
            {recentSessions.map(session => (
              <tr key={session.id}>
                <td>{session.created_at && formatToDayMonth(session.created_at)}</td>
                <td>{session.subject}</td>
                <td>{session.program}</td>
                <td>{session.students_present || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="dashboard-actions">
        <button onClick={() => navigate("/teacher/attendence")}>Generate QR Code</button>
      </div>
    </div>
  );
};

export default TeacherDashboard;
